import { Permission } from "./../../../utils/enum/permission.enum";
import { Component, inject, OnInit , signal} from "@angular/core";
import { AuthService, UserType } from "../auth";
import { environment } from "src/environments/environment";
import { SharedModule } from "src/shared/shared.module";
import { RouterModule } from "@angular/router";
import { Observable } from "rxjs";
import { CommonModule } from "@angular/common";
import { Role } from "src/utils/enum/role.enum";
import { NgxPermissionsModule } from "ngx-permissions";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-profile",
  imports: [
    SharedModule,
    RouterModule,
    CommonModule,
    NgxPermissionsModule,
    TranslateModule,
  ],
  templateUrl: "./profile.component.html",
  styleUrl: "./profile.component.scss",
})
export class ProfileComponent implements OnInit {
  /**
   * Whether the account navigation is showing on a phone.
   *
   * Below lg that navigation is a Metronic drawer, and the id its
   * `data-kt-drawer-toggle` points at did not exist anywhere in the app — so
   * the panel sat off-canvas with no handle and password, parent menu and the
   * study records could not be reached from the account screen at all. Driven
   * from here rather than from Metronic's own toggle binding, which is wired at
   * drawer-init time and does not see a control this lazy-loaded page renders.
   */
  navOpen = signal(false);

  #authService = inject(AuthService);
  currentUser = this.#authService.currentUser;
  fileUrl = environment.apiFileUrl;
  profileImg = this.fileUrl + this.currentUser()!.user.data.image_url;
  userObserve: Observable<UserType>;
  Role = Role;
  Permission = Permission;

  ngOnInit(): void {
    this.userObserve = this.#authService.currentUserSubject.asObservable();
  }
}
